import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as APIS from "../../../../../services/apis";

export function* handleFetchUserDetails({ payload }) {
  try {
    const res = yield call(APIS.fetchUserDetails, payload);
    const { data } = res;
    yield put(actions.fetchUserDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchUserDetailsFailure(err?.response?.data));
  }
}

export function* handleFetchCompanyDetails({ payload }) {
  try {
    const res = yield call(APIS.fetchCompanyDetails, payload);
    const { data } = res;
    yield put(actions.fetchCompanyDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyDetailsFailure(err?.response?.data));
  }
}
export function* handleFetchCompanyPickupAddress({ payload }) {
  try {
    const res = yield call(APIS.fetchPickupAddressForCompany, payload);
    const { data } = res;
    yield put(actions.fetchCompanyPickupAddressSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyPickupAddressFailure(err?.response?.data));
  }
}

export function* handleFetchCompanyBillingAddress({ payload }) {
  try {
    const res = yield call(APIS.fetchBillingAddressForCompany, payload);
    const { data } = res;
    yield put(actions.fetchCompanyBillingAddressSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyBillingAddressFailure(err?.response?.data));
  }
}

export function* handleUpdateUser({ payload }) {
  try {
    const res = yield call(APIS.updateUserDetails, payload);
    const { data } = res;
    yield put(actions.updateUserSuccess(data));
    payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.updateUserFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.updateUserFailure(err?.response?.data));
    payload.onFailure();
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* userEditSaga() {
  yield takeLatest(actions.fetchUserDetails.type, handleFetchUserDetails);
  yield takeLatest(actions.fetchCompanyDetails.type, handleFetchCompanyDetails);
  yield takeLatest(actions.updateUser.type, handleUpdateUser);
  yield takeLatest(
    actions.fetchCompanyPickupAddress,
    handleFetchCompanyPickupAddress
  );
  yield takeLatest(
    actions.fetchCompanyBillingAddress,
    handleFetchCompanyBillingAddress
  );
}
